import { create } from "zustand";

export type ToastType = "success" | "info" | "warning" | "error";

export interface ToastDto {
    id: string;
    type: ToastType;
    title: string;
    message: string;
}

interface ToastState {
    notifications: ToastDto[];
    addNotification: (n: ToastDto) => void;
    removeNotification: (id: string) => void;
}

export const useToastStore = create<ToastState>((set) => ({
    notifications: [],
    addNotification: (n) => set((s) => ({ notifications: [...s.notifications, n] })),
    removeNotification: (id) =>
        set((s) => ({ notifications: s.notifications.filter((x) => x.id !== id) })),
}));
